import { useRemoveSigner } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Documents/hooks/useRemoveSigner';
import { RemoveSignerModal } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Documents/components/RemoveSigner/RemoveSignerModal';
import type { RemovalTarget } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Documents/components/RemoveSigner/RemoveSignerModal.types';

interface Props {
	dealId: string;
	programmeId: string;
	documentWorkflowInstanceId: string;
	target: RemovalTarget | null;
	onClose: () => void;
}

/** Owns the confirmation modal and the mutation; the menu item only sets `target`. */
export const RemoveSignerAction = ({
	dealId,
	programmeId,
	documentWorkflowInstanceId,
	target,
	onClose,
}: Props) => {
	const { remove, isPending } = useRemoveSigner({
		dealId,
		programmeId,
		documentWorkflowInstanceId,
		onSuccess: onClose,
	});

	return (
		<RemoveSignerModal
			target={target}
			isPending={isPending}
			onConfirm={remove}
			onClose={onClose}
		/>
	);
};
